export default __webpack_public_path__ + "static/media/de.e0569fb1.jpg";